import React from 'react';
import '../styles/NavBar.css'
import '../../utils/GlobalStyles.css'

interface NavBarProps {
    logo: string;
}

const NavBar: React.FC<NavBarProps> = ({ logo }) => {
    return (
        <div className = 'navContainer shadow'>
            {/* logo ist eine volle data:-URI (korrekte MIME, inkl. SVG) oder http-URL. */}
            {logo && <img className = 'logo' src = {logo} alt = 'Logo' />}

            {/* <div className = 'icon'><Icon icon = 'fa-light fa-share-nodes' size = '25px'/></div> */}
        </div>
    )
};

export default NavBar;